import styled from 'styled-components';

export const SignatureSuccessDesktop = styled.div`
	display: flex;
	flex: 1;
	min-height: calc(100vh - 60px);
	padding: 32px;
	justify-content: center;
	background-color: #F5F5F5;
`;

SignatureSuccessDesktop.ContainerSignature = styled.div`
	min-height: 104px;
	border: 1px dashed #D9E1E8;
	border-radius: 12px;
	background-color: #FAFBFC;
`;

SignatureSuccessDesktop.SignatureBox = styled.img`
	max-width: 180px;
	max-height: 80px;
	width: 100%;
	margin: 0 auto;
	object-fit: contain;
`;

SignatureSuccessDesktop.Signature = styled.div`
	max-width: 600px;
`;

SignatureSuccessDesktop.SignatureContainer = styled.div`
	min-height: 520px;
	max-width: 600px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
	background-color: #FFF;
	color: #26282A;
	border-radius: 16px;
`;

SignatureSuccessDesktop.Header = styled.div`
	width: 100%;
	margin-bottom: 24px;
`;

SignatureSuccessDesktop.HeaderTitle = styled.p`
	font-weight: 700;
	font-size: 20px;
	color: #26282A;
	margin: 0 0 8px;
	line-height: 1.3;
`;

SignatureSuccessDesktop.HeaderSubtitle = styled.p`
	font-weight: 400;
	font-size: 14px;
	color: #4E5255;
	margin: 0;
	line-height: 1.4;
`;

SignatureSuccessDesktop.SignatureTitle = styled.p`
	font-weight: 500;
	font-size: 24px;
	line-height: 28px;
	text-align: center;
	color: #26282A;
	margin: 12px 0 8px;
`;

SignatureSuccessDesktop.SignatureText = styled.p`
	font-weight: 400;
	font-size: 14px;
	line-height: 1.4;
	text-align: center;
	color: #4E5255;
	margin: 0 0 24px;
`;

SignatureSuccessDesktop.UserContainer = styled.div`
	padding: 8px 0 24px;
	text-align: center;
`;

SignatureSuccessDesktop.UserName = styled.p`
	word-break: break-all;
	font-weight: 600;
	font-size: 18px;
	color: #26282A;
	line-height: 1.3;
	margin: 0 0 6px;
`;

SignatureSuccessDesktop.Cpf = styled.p`
	font-weight: 400;
	font-size: 16px;
	color: #4E5255;
	line-height: 1.3;
	margin: 0;
`;


SignatureSuccessDesktop.ImageSuccess = styled.img`
	width: 180px;
	height: auto;
	margin-bottom: 8px;
`;

SignatureSuccessDesktop.Button = styled.button`
	color: #26282A;
	border: 1px solid #D9E1E8;
	border-radius: 8px;
	height: 44px;
	display: flex;
	padding: 0 24px;
	justify-content: center;
	align-items: center;
	background-color: #FFF;
	cursor: pointer;
	transition: background-color 0.2s;

	&:hover:not(:disabled) {
		background-color: #F5F5F5;
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;

SignatureSuccessDesktop.ButtonText = styled.span`
	font-size: 16px;
	font-weight: 500;
`;
